import type { ProductEventName, TrackEvent } from '@secretario/shared';
import { API_BASE } from './api/http.js';
import { readSession } from './session.js';

const ANONYMOUS_KEY = 'secretario.anon';

function anonymousId(): string | undefined {
  try {
    let id = localStorage.getItem(ANONYMOUS_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(ANONYMOUS_KEY, id);
    }
    return id;
  } catch {
    return undefined;
  }
}

/**
 * Evento de produto (funil): só o nome e atributos curtos, nunca conteúdo.
 * É "dispara e esquece": métrica não pode atrasar nem quebrar a tela.
 */
export function track(name: ProductEventName, props?: TrackEvent['props']): void {
  const session = readSession();
  const anonymous = session ? undefined : anonymousId();
  const body: TrackEvent = {
    name,
    ...(anonymous ? { anonymousId: anonymous } : {}),
    ...(props ? { props } : {}),
  };
  void fetch(`${API_BASE}/v1/events`, {
    method: 'POST',
    keepalive: true,
    headers: {
      'content-type': 'application/json',
      ...(session ? { authorization: `Bearer ${session.session.accessToken}` } : {}),
    },
    body: JSON.stringify(body),
  }).catch(() => {});
}

/** Marcos que só fazem sentido uma vez por aparelho (ex.: ativação). */
export function trackOnce(name: ProductEventName, props?: TrackEvent['props']): void {
  const key = `secretario.evt.${name}`;
  try {
    if (localStorage.getItem(key)) return;
    localStorage.setItem(key, '1');
  } catch {
    /* sem armazenamento: registra de novo, sem problema */
  }
  track(name, props);
}
